import type { Country } from '@tenders/shared';
import { countryConfig } from '../country';

/**
 * Filled by `define` in `vite.config.ts` from the same `VITE_COUNTRY` that
 * `country.ts` reads, so in every Vite bundle (client, SSR, dev) it is a string
 * LITERAL. Undeclared anywhere Vite does not transform the code: vitest (its own
 * config, no `define`) and plain-`tsx` tooling such as `scripts/prerender.ts`.
 */
declare const __BUILD_COUNTRY__: Country | undefined;

/**
 * The deployment's country as a value Rollup can evaluate while it bundles.
 *
 * `countryConfig.code` is the same country, but it is read out of a registry
 * object at runtime, so a branch on it keeps every country's code in the bundle.
 * A branch on `BUILD_COUNTRY` is a branch on a literal: Rollup drops the dead
 * side and, with it, every module only that side imports. This is how the
 * MiLicita build ships no Uzbek or Kazakh guide text (`content/guide.ts`,
 * `content/guide-articles/index.ts`) — measured 2026-10-21, the Spanish guide
 * chunk carried every UZ/KZ article.
 *
 * Use it ONLY in the shape `BUILD_COUNTRY === 'xx' ? a : b` (or an `if`) for
 * choosing which content gets bundled; read everything else off `countryConfig`.
 * Outside Vite it falls back to `countryConfig.code`, so tests that mock
 * `../country` and the prerender (which reads `VITE_COUNTRY` from the process)
 * select exactly what the bundle selects.
 */
export const BUILD_COUNTRY: Country =
  typeof __BUILD_COUNTRY__ === 'string' ? __BUILD_COUNTRY__ : countryConfig.code;
